export const validateImage = (
  file,
  {
    minWidth = minWidth, // 300
    minHeight = minHeight, // 200
    maxFileSize = maxFileSize, // 1024 * 1024
    allowedExtensions = allowedExtensions, // ["png", "jpg", "jpeg"]
    allowedTypes = allowedTypes, // ["image/png", "image/jpg", "image/jpeg"]
    aspectRatio = aspectRatio, // 300 / 200
  } = {},
) => {
  return new Promise((resolve, reject) => {
    // Check file exists
    if (!file) {
      reject("Please select an image.");
      return;
    }

    // Check file extension
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      reject(
        `Only ${allowedExtensions.join(", ").toUpperCase()} images are allowed.`,
      );
      return;
    }

    // Check MIME type
    if (!allowedTypes.includes(file.type)) {
      reject(`Invalid image type. Allowed types: ${allowedTypes.join(", ")}`);
      return;
    }

    // Check file size
    if (file.size > maxFileSize) {
      reject(
        `Image size should be less than ${(maxFileSize / (1024 * 1024)).toFixed(
          0,
        )}MB.`,
      );
      return;
    }

    // Check image dimensions
    const image = new Image();
    const imageUrl = URL.createObjectURL(file);

    image.onload = () => {
      const width = image.naturalWidth;
      const height = image.naturalHeight;

      // console.log("Width:", width, "px");
      // console.log("Height:", height, "px");

      // Check minimum resolution
      if (width < minWidth || height < minHeight) {
        URL.revokeObjectURL(imageUrl);
        reject(
          `Image is too small (${width} × ${height}px). Please upload an image that is at least ${minWidth} x ${minHeight} pixels.`,
        );
        return;
      }

      // Check aspect ratio
      const actualRatio = width / height;

      // Allow a small tolerance for aspect ratio comparison
      const tolerance = 0.01;

      if (Math.abs(actualRatio - aspectRatio) > tolerance) {
        URL.revokeObjectURL(imageUrl);

        reject(
          `Invalid image dimensions (${width} × ${height}px). Please upload an image with a 3:2 aspect ratio, such as 300 × 200 or 600 × 400 pixels.`,
        );
        return;
      }

      URL.revokeObjectURL(imageUrl);

      resolve(true);
    };

    image.onerror = () => {
      URL.revokeObjectURL(imageUrl);
      reject("Invalid image.");
    };

    image.src = imageUrl;
  });
};
